(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const money = (cents) => {
    const currency = window.Vicinity?.currency || 'EUR';
    const locale = document.documentElement.lang || 'en';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch (_) { return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`; }
  };
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]));
  const shopifyImage = (url, width = 240) => {
    if (!url) return '';
    try {
      const parsed = new URL(url, location.origin);
      if (parsed.hostname === 'cdn.shopify.com' || parsed.hostname.endsWith('.shopifycdn.com')) {
        parsed.searchParams.set('width', String(width));
      }
      return parsed.toString();
    } catch (_) {
      return url;
    }
  };


  function openOverlay(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const focusable = el.querySelector('button, a, input, select, textarea');
    setTimeout(() => focusable?.focus(), 50);
  }
  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.is-open.cart-drawer, .is-open.header-drawer, .is-open.search-drawer')) document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-overlay]');
    if (opener) {
      event.preventDefault();
      openOverlay(document.getElementById(opener.dataset.openOverlay));
      return;
    }
    const closer = event.target.closest('[data-close-overlay]');
    if (closer) {
      event.preventDefault();
      closeOverlay(closer.closest('.header-drawer, .search-drawer, .cart-drawer'));
      return;
    }
    const tab = event.target.closest('[data-tab-target]');
    if (tab) {
      const group = tab.closest('[data-tabs]');
      if (!group) return;
      $$('.tab-button, .discovery__tab', group).forEach(btn => btn.classList.toggle('is-active', btn === tab));
      $$('[data-tab-panel]', group).forEach(panel => panel.hidden = panel.dataset.tabPanel !== tab.dataset.tabTarget);
      const image = $('[data-discovery-image]', group);
      if (image && tab.dataset.image) image.src = tab.dataset.image;
      return;
    }
    const quick = event.target.closest('[data-quick-toggle]');
    if (quick) {
      event.preventDefault();
      const card = quick.closest('.product-card');
      $$('.product-card.is-quick-open').forEach(openCard => { if (openCard !== card) openCard.classList.remove('is-quick-open'); });
      card?.classList.toggle('is-quick-open');
      return;
    }
    if (!event.target.closest('.product-card')) $$('.product-card.is-quick-open').forEach(card => card.classList.remove('is-quick-open'));
  });

  document.addEventListener('pointerover', (event) => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    const card = event.target.closest('.product-card');
    if (!card) return;
    const hover = card.querySelector('[data-hover-src], [data-card-hover][data-src]');
    const src = hover?.dataset.hoverSrc || hover?.dataset.src;
    if (hover && src && !hover.getAttribute('src')) hover.src = src;
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') $$('.is-open.header-drawer, .is-open.search-drawer, .is-open.cart-drawer').forEach(closeOverlay);
  });

  // Product gallery
  $$('[data-product-gallery]').forEach(gallery => {
    const main = $('[data-gallery-main]', gallery);
    const counter = $('[data-gallery-counter]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach((button, index, buttons) => {
      button.addEventListener('click', () => {
        buttons.forEach(btn => btn.classList.toggle('is-active', btn === button));
        if (main) {
          main.src = button.dataset.full;
          main.srcset = '';
          main.alt = button.dataset.alt || '';
        }
        if (counter) counter.textContent = `${index + 1}/${buttons.length}`;
      });
    });
  });

  // Product option buttons and variant resolution
  $$('[data-product-root]').forEach(root => {
    const variantData = JSON.parse($('[data-variants-json]', root)?.textContent || '[]');
    const variantInput = $('[name="id"]', root);
    const priceEl = $('[data-product-price]', root);
    const compareEl = $('[data-product-compare]', root);
    const submit = $('[data-product-submit]', root);
    const optionGroups = $$('[data-option-index]', root);

    const selectedOptions = () => optionGroups.map(group => $('.option-button.is-selected', group)?.dataset.value || '');
    const resolveVariant = () => variantData.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptions()));
    const sync = () => {
      const variant = resolveVariant();
      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = window.Vicinity?.strings?.unavailable || 'Unavailable'; }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        compareEl.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        compareEl.hidden = !(variant.compare_at_price > variant.price);
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (window.Vicinity?.strings?.addToCart || 'Add to cart') : (window.Vicinity?.strings?.soldOut || 'Sold out');
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    optionGroups.forEach(group => {
      $$('.option-button', group).forEach(button => button.addEventListener('click', () => {
        $$('.option-button', group).forEach(btn => btn.classList.toggle('is-selected', btn === button));
        sync();
      }));
    });
    sync();
  });

  // Split imported product HTML into Details and Fit Information.
  $$('[data-description-source]').forEach(source => {
    const root = source.closest('[data-product-root]');
    const detailsTarget = $('[data-details-target]', root);
    const fitTarget = $('[data-fit-target]', root);
    let target = detailsTarget;
    [...source.childNodes].forEach(node => {
      if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName) && /FIT INFORMATION/i.test(node.textContent || '')) {
        target = fitTarget;
        return;
      }
      target?.appendChild(node.cloneNode(true));
    });
    if (!fitTarget?.textContent.trim() && !fitTarget?.querySelector('img')) fitTarget.closest('details')?.remove();
    source.remove();
  });

  // Cart API and drawer
  const cartDrawer = $('#CartDrawer');
  const cartBody = $('[data-cart-body]', cartDrawer);
  const cartFooter = $('[data-cart-footer]', cartDrawer);
  const cartHeaderTitle = $('[data-cart-title]', cartDrawer);
  const productCache = new Map();

  async function jsonFetch(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json', ...(options.headers || {}) }, ...options });
    if (!response.ok) {
      let message = `Request failed (${response.status})`;
      try { message = (await response.json()).description || message; } catch (_) {}
      throw new Error(message);
    }
    return response.json();
  }
  async function getProduct(handle) {
    if (!handle) return null;
    if (!productCache.has(handle)) productCache.set(handle, jsonFetch(`/products/${handle}.js`).catch(() => null));
    return productCache.get(handle);
  }
  const setLoading = (loading) => cartDrawer?.classList.toggle('is-loading', loading);

  async function updateCartCount(cart) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  async function renderCart(open = false) {
    if (!cartDrawer) return;
    setLoading(true);
    try {
      const cart = await jsonFetch('/cart.js');
      await updateCartCount(cart);
      if (cartHeaderTitle) cartHeaderTitle.textContent = `YOUR CART (${cart.item_count} ITEM${cart.item_count === 1 ? '' : 'S'})`;
      if (cart.item_count === 0) {
        cartBody.innerHTML = $('#CartEmptyTemplate')?.innerHTML || '<div class="cart-empty">Your cart is empty</div>';
        window.VicinityVirtual?.renderWithin?.(cartBody);
        cartFooter.hidden = true;
      } else {
        const products = await Promise.all(cart.items.map(item => getProduct(item.handle)));
        let compareTotal = 0;
        const rows = cart.items.map((item, index) => {
          const product = products[index];
          const selectedVariant = product?.variants?.find(v => Number(v.id) === Number(item.variant_id));
          const compare = selectedVariant?.compare_at_price || 0;
          compareTotal += Math.max(0, compare * item.quantity - item.final_line_price);
          const options = product?.variants?.filter(v => v.available || Number(v.id) === Number(item.variant_id)).map(v => `<option value="${v.id}" ${Number(v.id) === Number(item.variant_id) ? 'selected' : ''}>${escapeHtml(v.title)}</option>`).join('') || '';
          const qtyOptions = Array.from({length: 10}, (_, i) => i + 1).map(q => `<option value="${q}" ${q === item.quantity ? 'selected' : ''}>${q}</option>`).join('');
          const image = shopifyImage(item.featured_image?.url || item.image || '', 240);
          return `<article class="cart-line" data-line="${index + 1}">
            <a href="${item.url}"><img class="cart-line__image" src="${image}" alt="${escapeHtml(item.product_title)}" loading="lazy" decoding="async" width="92" height="112"></a>
            <div>
              <a href="${item.url}"><h3 class="cart-line__title">${escapeHtml(item.product_title)}</h3></a>
              <div class="cart-line__selectors">
                <label class="visually-hidden" for="CartQty-${index}">Quantity</label>
                <select id="CartQty-${index}" data-cart-quantity>${qtyOptions}</select>
                ${options ? `<label class="visually-hidden" for="CartVariant-${index}">Variant</label><select id="CartVariant-${index}" data-cart-variant>${options}</select>` : `<span>${escapeHtml(item.variant_title || '')}</span>`}
              </div>
              <button class="cart-line__remove" type="button" data-cart-remove aria-label="Remove ${escapeHtml(item.product_title)}">⌫</button>
            </div>
            <div class="cart-line__price">${compare > item.final_price ? `<span class="cart-line__compare">${money(compare * item.quantity)}</span>` : ''}<span>${money(item.final_line_price)}</span></div>
          </article>`;
        }).join('');
        cartBody.innerHTML = rows;
        $('[data-cart-saved]', cartFooter).textContent = money(compareTotal || cart.total_discount || 0);
        $('[data-cart-subtotal]', cartFooter).textContent = money(cart.total_price);
        cartFooter.hidden = false;
      }
      if (open) openOverlay(cartDrawer);
    } catch (error) {
      console.error(error);
      if (open) alert(error.message);
    } finally {
      setLoading(false);
    }
  }

  async function changeCart(line, quantity, variantId = null) {
    setLoading(true);
    try {
      if (variantId) {
        await jsonFetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ line, quantity: 0 }) });
        await jsonFetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) }] }) });
      } else {
        await jsonFetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ line, quantity: Number(quantity) }) });
      }
      await renderCart(false);
    } catch (error) { alert(error.message); setLoading(false); }
  }

  cartDrawer?.addEventListener('change', event => {
    const lineEl = event.target.closest('[data-line]');
    if (!lineEl) return;
    const line = Number(lineEl.dataset.line);
    const qty = Number($('[data-cart-quantity]', lineEl)?.value || 1);
    if (event.target.matches('[data-cart-quantity]')) changeCart(line, qty);
    if (event.target.matches('[data-cart-variant]')) changeCart(line, qty, event.target.value);
  });
  cartDrawer?.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) changeCart(Number(remove.closest('[data-line]').dataset.line), 0);
  });

  document.addEventListener('click', event => {
    const cartOpen = event.target.closest('[data-open-cart]');
    if (cartOpen) { event.preventDefault(); renderCart(true); }
  });

  async function addItems(items, open = true) {
    setLoading(true);
    try {
      await jsonFetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ items }) });
      await renderCart(open);
    } catch (error) { alert(error.message); setLoading(false); }
  }

  document.addEventListener('click', event => {
    const quickVariant = event.target.closest('[data-quick-variant]');
    if (quickVariant) {
      event.preventDefault();
      if (!quickVariant.disabled) addItems([{ id: Number(quickVariant.dataset.quickVariant), quantity: 1 }]);
    }
  });

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const data = new FormData(form);
    const id = Number(data.get('id'));
    const quantity = Number(data.get('quantity') || 1);
    if (id) addItems([{ id, quantity }]);
  });

  const lookForm = $('[data-complete-look]');
  lookForm?.addEventListener('submit', event => {
    event.preventDefault();
    const items = $$('[data-look-item]', lookForm).filter(item => $('[data-look-check]', item)?.checked).map(item => ({
      id: Number($('[data-look-variant]', item)?.value),
      quantity: 1
    })).filter(item => item.id);
    if (items.length) addItems(items);
  });
  function updateLookTotal() {
    if (!lookForm) return;
    const total = $$('[data-look-item]', lookForm).filter(item => $('[data-look-check]', item)?.checked).reduce((sum, item) => {
      const select = $('[data-look-variant]', item);
      return sum + Number(select?.selectedOptions?.[0]?.dataset.price || 0);
    }, 0);
    const totalEl = $('[data-look-total]', lookForm);
    if (totalEl) totalEl.textContent = money(total);
  }
  lookForm?.addEventListener('change', updateLookTotal);
  updateLookTotal();

  // Newsletter/contact forms: preserve Shopify's native submission behavior.
  // Cart contents are fetched only when the customer opens the drawer.
})();
